import { render, staticRenderFns } from "./footer-component.vue?vue&type=template&id=3cd16241&"
var script = {}
import style0 from "./footer-component.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "footer-component.vue"
export default component.exports